<template>
  <label class="container"
    ><slot></slot>
    <input
      v-model="internalValue"
      @input="onInputChange"
      type="checkbox"
      :disabled="disabled"
      :required="required"
    />
    <span class="checkmark" :style="cssProps"></span>
  </label>
</template>

<style lang="scss" scoped>
@import "../variables.scss";

.container.large-checkbox {
  .checkmark {
    height: 3rem;
    width: 3rem;
    border-radius: 1rem;
    transition: all $site-transition-speed;
  }

  .checkmark::after {
    left: 17px;
    top: 5px;
    width: 10px;
    height: 26px;
    border-width: 0 6px 6px 0;
  }
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 2.4rem;
  line-height: 30px;
  transition: all $site-transition-speed;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 1px;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  transition: all $site-transition-speed;
  border-radius: 0.5rem;
  border: 1px solid #dddddd;
  box-shadow: 0px 0px 14px $color-box-shadow;
  background: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ddd;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: var(--checkmarkColorBg);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 3px;
  width: 5px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>

<script>
export default {
  name: "BisgrafCheckbox",

  props: {
    value: {
      type: Boolean,
      required: true
    },
    primary: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      internalValue: this.value
    };
  },

  methods: {
    onInputChange() {
      this.$emit("input", this.internalValue);
    }
  },

  watch: {
    value() {
      this.internalValue = this.value;
    }
  },

  computed: {
    cssProps() {
      return {
        // changed css for iframe "--checkmarkColorBg": this.primary ? "#0272c4" : "#f99b01"
        "--checkmarkColorBg": this.primary ? "#337078" : "#337078"
      };
    }
  }
};
</script>
